var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "btn4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_940_2935",
    maskUnits: "userSpaceOnUse",
    x: 13.4485,
    y: 10.7808,
    width: 13,
    height: 18,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 13.4485,
    y: 10.7808,
    width: 13,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5617 12.5911C25.5544 12.1423 25.1883 11.7808 24.7378 11.7808C24.2827 11.7808 23.9138 12.1497 23.9138 12.6047V18.3327L15.7803 11.9662C15.2395 11.5429 14.4485 11.9282 14.4485 12.6151V27.3848C14.4485 28.0716 15.2395 28.457 15.7803 28.0336L23.9138 21.6671V27.3951L23.9139 27.4087C23.9212 27.8575 24.2873 28.2191 24.7378 28.2191C25.1929 28.2191 25.5618 27.8501 25.5618 27.3951V12.6047L25.5617 12.5911ZM16.0964 25.6934L23.3702 19.9999L16.0964 14.3064V25.6934Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5617 12.5911C25.5544 12.1423 25.1883 11.7808 24.7378 11.7808C24.2827 11.7808 23.9138 12.1497 23.9138 12.6047V18.3327L15.7803 11.9662C15.2395 11.5429 14.4485 11.9282 14.4485 12.6151V27.3848C14.4485 28.0716 15.2395 28.457 15.7803 28.0336L23.9138 21.6671V27.3951L23.9139 27.4087C23.9212 27.8575 24.2873 28.2191 24.7378 28.2191C25.1929 28.2191 25.5618 27.8501 25.5618 27.3951V12.6047L25.5617 12.5911ZM16.0964 25.6934L23.3702 19.9999L16.0964 14.3064V25.6934Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5617 12.5911L25.7617 12.5896L25.7616 12.5879L25.5617 12.5911ZM23.9138 18.3327L23.7905 18.4902L24.1138 18.7432V18.3327H23.9138ZM15.7803 11.9662L15.6571 12.1237L15.6571 12.1237L15.7803 11.9662ZM15.7803 28.0336L15.6571 27.8761H15.6571L15.7803 28.0336ZM23.9138 21.6671H24.1138V21.2566L23.7905 21.5097L23.9138 21.6671ZM23.9138 27.3951H23.7138L23.7138 27.3966L23.9138 27.3951ZM23.9139 27.4087L23.7139 27.4102L23.7139 27.4119L23.9139 27.4087ZM25.5618 12.6047H25.7618L25.7618 12.6032L25.5618 12.6047ZM23.3702 19.9999L23.4934 20.1574L23.6946 19.9999L23.4934 19.8424L23.3702 19.9999ZM16.0964 25.6934H15.8964V26.104L16.2197 25.8509L16.0964 25.6934ZM16.0964 14.3064L16.2197 14.1489L15.8964 13.8959V14.3064H16.0964ZM24.7378 11.9808C25.0789 11.9808 25.3562 12.2546 25.3617 12.5944L25.7616 12.5879C25.7526 12.0301 25.2977 11.5808 24.7378 11.5808V11.9808ZM24.1138 12.6047C24.1138 12.2601 24.3932 11.9808 24.7378 11.9808V11.5808C24.1723 11.5808 23.7138 12.0392 23.7138 12.6047H24.1138ZM24.1138 18.3327V12.6047H23.7138V18.3327H24.1138ZM24.0371 18.1752L15.9036 11.8087L15.6571 12.1237L23.7905 18.4902L24.0371 18.1752ZM15.9036 11.8087C15.2315 11.2826 14.2485 11.7615 14.2485 12.6151H14.6485C14.6485 12.0949 15.2475 11.8031 15.6571 12.1237L15.9036 11.8087ZM14.2485 12.6151V27.3848H14.6485V12.6151H14.2485ZM14.2485 27.3848C14.2485 28.2384 15.2315 28.7172 15.9036 28.1911L15.6571 27.8761C15.2475 28.1967 14.6485 27.9049 14.6485 27.3848H14.2485ZM15.9036 28.1911L24.0371 21.8246L23.7905 21.5097L15.6571 27.8761L15.9036 28.1911ZM24.1138 27.3951V21.6671H23.7138V27.3951H24.1138ZM24.1139 27.4072L24.1138 27.3936L23.7138 27.3966L23.7139 27.4102L24.1139 27.4072ZM24.7378 28.0191C24.3967 28.0191 24.1194 27.7453 24.1139 27.4054L23.7139 27.4119C23.723 27.9697 24.1779 28.4191 24.7378 28.4191V28.0191ZM25.3618 27.3951C25.3618 27.7397 25.0824 28.0191 24.7378 28.0191V28.4191C25.3033 28.4191 25.7618 27.9606 25.7618 27.3951H25.3618ZM25.3618 12.6047V27.3951H25.7618V12.6047H25.3618ZM25.3617 12.5926L25.3618 12.6062L25.7618 12.6032L25.7617 12.5896L25.3617 12.5926ZM23.2469 19.8424L15.9732 25.5359L16.2197 25.8509L23.4934 20.1574L23.2469 19.8424ZM15.9732 14.4639L23.2469 20.1574L23.4934 19.8424L16.2197 14.1489L15.9732 14.4639ZM16.2964 25.6934V14.3064H15.8964V25.6934H16.2964Z",
    fill: "#222222",
    mask: "url(#path-2-outside-1_940_2935)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.9433f28c7d171cdb4533d10cb7ea6344.svg";
export { ForwardRef as ReactComponent };